<template>
  <div class="insight-chart">
    <canvas ref="chartCanvas" :height="height"></canvas>
  </div>
</template>

<script>
import Chart from '@/utils/chart';

export default {
  name: 'InsightLineChart',
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({
        labels: [],
        datasets: [],
      }),
    },
    height: {
      type: Number,
      default: 300,
    },
  },
  data() {
    return {
      chartInstance: null,
    };
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.updateChart();
      },
    },
  },
  mounted() {
    this.createChart();
  },
  beforeDestroy() {
    if (this.chartInstance) {
      this.chartInstance.destroy();
    }
  },
  methods: {
    createChart() {
      if (this.chartInstance) {
        this.chartInstance.destroy();
      }

      const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: this.data.datasets.length > 1,
          position: 'top',
        },
        elements: {
          line: {
            tension: 0.3,
          },
          point: {
            radius: 3,
            hoverRadius: 5,
          },
        },
        scales: {
          xAxes: [{
            gridLines: {
              display: false,
            },
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
            },
          }],
        },
        tooltips: {
          mode: 'index',
          intersect: false,
        },
      };

      this.chartInstance = new Chart(this.$refs.chartCanvas, {
        type: 'line',
        data: this.data,
        options: chartOptions,
      });
    },
    updateChart() {
      if (this.chartInstance) {
        this.chartInstance.data = this.data;
        this.chartInstance.update();
      } else {
        this.createChart();
      }
    },
  },
};
</script>

<style scoped>
.insight-chart {
  position: relative;
  height: 300px;
}
</style>

